import { render } from "./taskCenter.vue?vue&type=template&id=d3676aba&scoped=true"
import script from "./taskCenter.vue?vue&type=script&lang=js"
export * from "./taskCenter.vue?vue&type=script&lang=js"

import "./taskCenter.vue?vue&type=style&index=0&id=d3676aba&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3676aba"]])

export default __exports__